import { useListKadryBotsQuery } from '@shared/api';
import { KadryErrorBanner, KadryStack } from '../ui';
import { SourceConnectionsCard } from './SourceConnectionsCard';
import { BotConnectionsCard } from './BotConnectionsCard';
import { SmsStatusCard } from './SmsStatusCard';
import { BudgetsCard } from './BudgetsCard';

/** Подключения: hh.ru, Работа.ру, боты Telegram и MAX, SMS, готовность к работе. */
export function Connections() {
  const bots = useListKadryBotsQuery();
  return (
    <KadryStack>
      <SourceConnectionsCard source="hh" />
      <SourceConnectionsCard source="rabota" />
      {bots.error ? <KadryErrorBanner error={bots.error} onRefresh={bots.refetch} /> : null}
      {(bots.data ?? []).map((b) => (
        <BotConnectionsCard key={b.channel} status={b} />
      ))}
      <SmsStatusCard />
      <BudgetsCard />
    </KadryStack>
  );
}

export { SourceConnectionsCard, SourceConnectionsCard as SourceCard } from './SourceConnectionsCard';
export { TariffsQuotasCard, TariffsQuotasCard as HhQuotas } from './TariffsQuotasCard';
export { BotConnectionsCard, BotConnectionsCard as BotCard } from './BotConnectionsCard';
export { SmsStatusCard, SmsStatusCard as SmsCard } from './SmsStatusCard';
export { BudgetsCard, BudgetsCard as ReadinessCard, MoneyBlock, ProfileApprove } from './BudgetsCard';
